import DisputesApi from "../../services/api/Disputes";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import Errors from "../../constants/Errors.json";
import { getQueryParams, protoTimestampToIST } from "../../utils";

const handleError = (err) => {
  console.log("[handleError] Error in Disputes actions", err);
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_DISPUTES_LIST_FILTERS,
    payload,
  };
};

export const setDisputesList = (payload) => {
  return {
    type: ActionTypes.SET_DISPUTES_LIST,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_DISPUTES_LIST_AND_FILTERS,
    payload,
  };
};

export const setDisputesDetails = (payload) => {
  return {
    type: ActionTypes.SET_DISPUTES_DETAILS,
    payload,
  };
};

// resetDisputeDetails
export const resetDisputesDetails = (payload) => {
  return {
    type: ActionTypes.RESET_DISPUTES_DETAILS,
    payload,
  };
};

export const getDisputesList = (params) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    dispatch(setActiveFilters(params));
    let response = await DisputesApi.getDisputesList(getQueryParams(params));
    dispatch(setLoader(false));
    if (response) {
      if (response.disputes) {
        response.disputes.forEach(dispute => {
            dispute.created_at = dispute?.created_at?.seconds ? protoTimestampToIST(dispute?.created_at?.seconds) : "-";
            dispute.updated_at = dispute?.updated_at?.seconds ? protoTimestampToIST(dispute?.updated_at?.seconds) : "-";
        });
       }
      if (JSON.stringify(response) == "{}") {
        dispatch(
          setStatus({
            type: "error",
            message: Errors.NO_DATA_FOUND
          }));
        return response;
      }
      dispatch(setDisputesList(response));
      dispatch(setDisputesDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDisputeDetails = (params) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DisputesApi.getDisputesList(getQueryParams(params));
    dispatch(setLoader(false));
    if (response) {
      if (response.disputes) {
        response.disputes.forEach(dispute => {
            dispute.created_at = dispute?.created_at?.seconds ? protoTimestampToIST(dispute?.created_at?.seconds) : "-";
            dispute.updated_at = dispute?.updated_at?.seconds ? protoTimestampToIST(dispute?.updated_at?.seconds) : "-";
        });
       }
      dispatch(setDisputesDetails(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getUploadUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DisputesApi.getUploadUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDisputeTypes = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DisputesApi.getDisputeTypes();
    dispatch(setLoader(false));
    return response;
  }
  catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
